/*解决方案*/
export default {
  path: '/solution',
  component: resolve => require(['@/views/solution'], resolve),
   children: [
    {
      path: '1',
      component: resolve => require(['@/views/solution/solution_1.vue'], resolve)
    },
    {
      path: '2',
      component: resolve => require(['@/views/solution/solution_2.vue'], resolve)
    },
    {
      path: 'mob_list',
      component: resolve => require(['@/components/details_figure_mobile/solution'], resolve)
    },
    {
      path: 'mob_1',
      component: resolve => require(['@/views/solution_mob/solution_1.vue'], resolve)
    },
    {
      path: 'mob_2',
      component: resolve => require(['@/views/solution_mob/solution_2.vue'], resolve)
    }
  ]
}
